import React from 'react';

import { SMART_BANNER_ID } from '~/src/common/components/BodyScripts/AppsflyerSmartBanner';
import Footer from '~/src/common/components/Layout/Footer';
import HeaderNavigation from '~/src/common/components/Layout/Navigation';

const CommonLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <div id={SMART_BANNER_ID} />
    <HeaderNavigation />
    {children}
    <Footer />
  </>
);

export default CommonLayout;
